import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";

const ReadingGuideCard = ({ guide, testId }) => (
  <Link
    to={`/reading-guides/${guide.slug}`}
    data-testid={testId}
    className="cozy-card group block rounded-3xl overflow-hidden h-full"
  >
    <div className="relative aspect-[16/10] overflow-hidden">
      <img
        src={guide.cover}
        alt=""
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
      />
      <div className="absolute inset-0 book-spine pointer-events-none" />
      <span
        className="absolute top-4 left-4 px-3 py-1 rounded-full text-[11px] font-semibold tracking-wider uppercase"
        style={{
          background: "var(--surface)",
          color: "var(--brand)",
          border: "1px solid var(--border)",
        }}
      >
        {guide.tag}
      </span>
    </div>
    <div className="p-6 flex flex-col flex-1">
      <h3
        className="font-serif text-2xl font-medium mb-2"
        style={{ color: "var(--text)" }}
      >
        {guide.title}
      </h3>
      <p
        className="text-sm italic font-serif mb-3"
        style={{ color: "var(--text-muted)" }}
      >
        By {guide.author}
      </p>
      <p className="text-sm flex-1 leading-relaxed" style={{ color: "var(--text-soft)" }}>
        {guide.excerpt}
      </p>
      {guide.topics && (
        <div className="mt-4 flex flex-wrap gap-2">
          {guide.topics.map((topic) => (
            <span
              key={topic}
              className="text-[10px] px-2.5 py-1 rounded-full uppercase tracking-wider font-medium"
              style={{
                background: "var(--bg-alt)",
                color: "var(--text-muted)",
              }}
            >
              {topic}
            </span>
          ))}
        </div>
      )}
      <div
        className="mt-5 flex items-center justify-between pt-5 border-t"
        style={{ borderColor: "var(--border-soft)" }}
      >
        <span
          className="inline-flex items-center gap-1.5 text-xs font-medium"
          style={{ color: "var(--text-muted)" }}
        >
          <Clock className="w-3.5 h-3.5" />
          {guide.readTime}
        </span>
        <div
          className="w-9 h-9 rounded-full flex items-center justify-center transition-colors group-hover:bg-[var(--brand-tint)]"
          style={{ background: "var(--bg-alt)", color: "var(--brand)" }}
        >
          <ArrowUpRight className="w-4 h-4" />
        </div>
      </div>
    </div>
  </Link>
);

export default ReadingGuideCard;
